<div class="container-box product-configurator" *ngIf="producDetails !== null">
  <h1>{{licenseType}} licenses</h1>
  <!-- Error Block -->
  <div class="error-container" aria-live="assertive">
    <div class="alert valign-children-middle" *ngIf='setError'>
      <div class="alert-error" aria-label="Alert.">
        <i class="icon-badgealert" aria-hidden="true"></i>
      </div>
      <div>
        <h2 *ngIf='!errorFlag'>Please note</h2>
        <h2 *ngIf='errorFlag'>We can't remove licenses</h2>
        <p [innerHTML]='ErrorMessage'></p>
        <a *ngIf='showRemoveallLink' href="javascript:void(0)" (click)='removeAllFlow()'>Remove all licenses</a>
        <a *ngIf='showErrLink' href="javascript:void(0)" (click)='unassingUserFlow()'>Please unassign users and try again.</a>
      </div>
    </div>
  </div>
  <!-- Error Block End -->
  <section>
    <div><label class="data-label">Selected product:</label> </div>
    <div>{{producDetails.specName}}</div>
    <div><label class="data-label">Foundation account number:</label> {{producDetails.brokerAccountClientId}}</div>
    <div><label class="data-label">Wireless number:</label> {{billingClientId}}</div>
    <div>{{producDetails && producDetails.productDesc}}</div>
  </section>
  <form [formGroup]="modifyLicenseForm" autocomplete="off">
    <div class='lisence-container'>
      <div class="row">
        <div class="qty-block already-own">
          <div class='col-md-9'>
            <span>You currently own</span>
            <div class="margin-top"> {{producDetails.quantity}} <span class="license" [innerHTML]="(producDetails.quantity > 1)? 'licenses':'license'"></span>              &#64; {{unitPrice | currency:'USD':true:'1.2-3' }} /user</div>
          </div>
          <div class='col-sm-12 col-md-3'>
            <div class="price-detail">
              <div class="price-value">{{ ownedProductPrice | currency:'USD':true:'1.2-3' }}</div>
              <div class="per-month">per month </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="lisence-container">
      <h3>{{licenseModifyType}} licenses</h3>

      <div class="row">
        <div class="qty-block">
          <div class="col-md-12">
            <div class="row">
              <div class='col-sm-10 col-md-6'>
                <label>License price per month:</label>
                <div class="mar-bot-20" *ngFor="let iterateVolumeContent of volumeDiscount; let contentIndex = index">
                  <div *ngIf="contentIndex === 0">
                    {{((iterateVolumeContent?.customAmount) ? iterateVolumeContent?.customAmount : iterateVolumeContent.amount) | currency:'USD':true:'1.2-3'}}/license
                  </div>
                  <div *ngIf="feeType === 'Tiered' && contentIndex > 0">
                    {{((iterateVolumeContent?.customAmount) ? iterateVolumeContent?.customAmount : iterateVolumeContent.amount) | currency:'USD':true:'1.2-3'}}/user
                    if > {{iterateVolumeContent.minQty - 1}}

                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-12 margin-bot">
                <label for="enter-quantity" class="label-block custom-label" [ngClass]="{'error-field': formErrors.qty}">Number of licenses to {{validationLicenseModifyType}} </label>
              </div>
              <div class='col-md-4 add-quantity'>
                <div class="row">
                  <div class="col-sm-7 col-md-6">
                    <input id="enter-quantity" *ngIf='licenseModifyType === "Add"' [attr.aria-describedby]="formErrors.qty ? 'qtyErrBlock' : null"
                      aria-label="Enter the number of licenses to add." type="text" class="form-control mar-top5" [class.text-error]="formErrors.qty"
                      formControlName="qty" maxlength="5">
                    <input id="enter-quantity" *ngIf='licenseModifyType !== "Add"' [attr.aria-describedby]="formErrors.qty ? 'qtyErrBlock' : null"
                      aria-label="Enter the number of licenses to remove." type="text" class="form-control mar-top5" [class.text-error]="formErrors.qty"
                      formControlName="qty" maxlength="5">
                  </div>
                  <div class="col-sm-5 col-md-6 pad-left-0">
                    <button type="button" class="btn btn-secondary btn-update btn-sm" [disabled]="modifyLicenseForm.invalid || impoErr" (click)='getUpdatedPricing()'
                      aria-label="Update.">Update</button>
                  </div>
                  <div *ngIf="formErrors.qty" id='qtyErrBlock' aria-live="polite" aria-atomic="true" class="text-danger col-sm-12 col-md-10 qty-error">
                    {{ formErrors.qty }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class='singeline totalcontainer' aria-live="polite" aria-atomic="true">
      <div class='row'>
        <div class='col-md-7 col-sm-12'>
          <h3 class="heading-bold">Total charges*</h3>
          <div>{{tmpTotalQty}} <span [innerHTML]="(tmpTotalQty > 1)? 'licenses':'license'"></span> &#64; {{ totUnitPrice | currency:'USD':true:'1.2-3'
            }}/user</div>
        </div>
        <div class='col-sm-10 col-md-5 radio-margin'>
          <div class="price-detail">
            <p class="price-value">{{ TotalAmt | currency:'USD':true:'1.2-3' }}</p>
            <p class="per-month">per month</p>
          </div>
        </div>
      </div>
    </div>
    <small>*Totals are based on estimated charges. Taxes and fees will be calculated for applicable charges. Charges will appear on your billing statement. You may not see any discounts or bill credits subtracted from your charges until you select your billing account on the <strong>Checkout</strong> page.</small>

    <hr class="cart-hr hide-sm" />
    <div class='text-right checkout-btn'>
      <button type="button" class="btn btn-success btn-cart pull-right" [disabled]="!modifyLicenseForm.valid || !this.isFormValid || priceErr"
        (click)='checkForModifyType()' aria-label="Check out.">Checkout</button>
      <a class="btn btn-link btn-cart" href="javascript:void(0)" [routerLink]="['/manageProduct']">Cancel</a>
    </div>
  </form>
</div>
<app-mobile-pivot [pivots]="pivots"></app-mobile-pivot>